export function getFormValueLocal(fieldName, silent=true) {
    try {
        return JSON.parse(window.localStorage.PricingForm)["formFields"][fieldName]
    } catch(e) {
        if (!silent){
            console.error(e)
        }
        return ""
    }
}
